import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { TranslateService } from '@ngx-translate/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Subscription } from 'rxjs';

import { AuthService } from '@app/core/auth';
import { KitService } from '@app/core/kits/services/kit.service';
import { CommentType, CommentService } from '@app/core/messaging';
import { RfqService } from '@app/core/quotes';
import { environment } from '@app/env-service';

@Component({
  selector: 'cnc-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit, OnDestroy {
  url :string = environment.url;

  pageSize = 100;
  pageSizeOptions :number[] = [5, 10, 25, 100];
  params :any = {
    per_page: 20,
    page: 1,
  };

  ps :any;

  subscription :Subscription;
  skuSubscription :Subscription;

  svc :any;

  constructor(
    public commentSvc :CommentService,
    private translate :TranslateService,
    private cd :ChangeDetectorRef,
    public rfqService :RfqService,
    public authSvc :AuthService,
    public kitService :KitService,
  ) {}

  @Input() commentType :CommentType;

  ngOnInit() {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.skuSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.setScrollbar();

    if (this.commentType.ref_tab_type == 3) {
      // kits
      this.svc = this.kitService;
    } else {
      // rfq, quote
      this.svc = this.rfqService;
    }

    this.skuSubscription = this.svc.activeRecord$.subscribe((data) => {
      if (data && data.id) {
        this.commentType.ref_tab_id = data.id;
        this.getRecords();
      }
    });

    this.subscription = this.commentSvc.record$.subscribe((resp) => {
      setTimeout(() => {
        if (this.ps) {
          this.ps.update();
        }
        this.updateScroll();
      }, 100);
    });
  }

  setScrollbar() {
    const element = document.getElementById('messages');
    if (!element) {
      setTimeout(() => {
        this.setScrollbar();
      }, 100);

      return;
    }
    this.ps = new PerfectScrollbar('#messages', {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 10,
      suppressScrollX: true,
    });
  }

  updateScroll() {
    const element = document.getElementById('messages');
    if (!element) {
      return;
    }
    element.scrollTop = element.scrollHeight;
  }

  getRecords(event ?:PageEvent) {
    if (!this.commentType || !this.commentType.ref_tab_id) {
      setTimeout(() => {
        this.getRecords();
      }, 100);

      return;
    }
    let params :any = { page: 1, per_page: this.pageSize };
    params = { ...params, ...this.commentType };

    if (event) {
      params.page = event.pageIndex + 1;
      params.per_page = event.pageSize;
    }
    this.commentSvc.setParams(params);
    this.commentSvc.refreshList();
  }
}
